var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#3CA4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.78585C25.2639 10.1205 24.4704 10.3403 23.6482 10.4455C24.4895 9.93881 25.1396 9.13575 25.4455 8.17017C24.652 8.64818 23.7725 8.98279 22.8451 9.17399C22.0899 8.35181 21.0287 7.8738 19.8241 7.8738C17.5774 7.8738 15.7419 9.70937 15.7419 11.9751C15.7419 12.3002 15.7801 12.6157 15.847 12.912C12.4436 12.74 9.413 11.1052 7.39579 8.62906C7.04207 9.23135 6.8413 9.93881 6.8413 10.6845C6.8413 12.109 7.55832 13.3709 8.6673 14.088C7.98853 14.088 7.35755 13.8967 6.80306 13.6099V13.6386C6.80306 15.6271 8.21797 17.2906 10.0918 17.6635C9.49018 17.8281 8.8586 17.851 8.24665 17.7304C8.50632 18.5454 9.01485 19.2585 9.70078 19.7695C10.3867 20.2805 11.2155 20.5638 12.0707 20.5793C10.6211 21.727 8.82409 22.3473 6.97514 22.3384C6.6501 22.3384 6.32505 22.3193 6 22.2811C7.81644 23.4474 9.97706 24.1262 12.2906 24.1262C19.8241 24.1262 23.9637 17.8738 23.9637 12.4532C23.9637 12.2715 23.9637 12.0994 23.9541 11.9178C24.7572 11.3442 25.4455 10.6176 26 9.78585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterColor);
export default __webpack_public_path__ + "static/media/twitterColor.c68685726675dba6fb73bc54150493c9.svg";
export { ForwardRef as ReactComponent };